module.exports = __webpack_public_path__ + "images/emoji/arrows_counterclockwise.6814bfe0fcd82a49b660.png";